import React from "react";
import { Route } from "react-router-dom";
// Custom imports
import { userIsAuthenticated } from "@globalholdings/ui-common-functions";
import Login from "../Login";

export default function PrivateRoute(props) {
  const { component: Component, temporary: Temporary, ...rest } = props;

  return (
    <Route
      {...rest}
      render={props =>
        userIsAuthenticated() ? <Component {...props} /> : <Login />
      }
    />
  );
}
